const panel = document.getElementById('almc-shop-measurement');
if (panel) {
    const endpoint = panel.dataset.endpoint;
    const actions = [...panel.querySelectorAll('[data-measurement-action]')];
    const error = panel.querySelector('[data-measurement-error]');
    const close = panel.querySelector('[data-measurement-close]');
    const openers = [...document.querySelectorAll('[data-measurement-manage]')];
    let csrf = null;
    let choice = null;
    let enabled = false;
    let busy = false;
    let lastOpener = null;
    // Only in memory until consent. No SDK, external request, localStorage or tracking cookie.
    const query = new URLSearchParams(window.location.search);
    const ref = query.get('oppref');
    const bytes = ref ? new TextEncoder().encode(ref) : null;
    const encoded = bytes && bytes.length <= 2048 ? btoa(String.fromCharCode(...bytes)) : null;
    const campaign = /^[a-zA-Z0-9_-]{1,128}$/.test(query.get('utm_campaign') || '') ? query.get('utm_campaign') : null;
    function controls() {
        actions.forEach(button => { button.disabled = busy || (button.dataset.measurementAction === 'accept' && !enabled); });
        close.hidden = choice === null;
    }
    async function send(action) {
        if (busy || !csrf) return;
        busy = true;
        error.hidden = true;
        controls();
        try {
            const response = await fetch(endpoint, {
                method: 'POST', credentials: 'same-origin', cache: 'no-store',
                headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-TOKEN': csrf},
                body: JSON.stringify({action, ...(action !== 'reject' ? {click_ref_base64: encoded, campaign} : {})}),
            });
            if (!response.ok) throw new Error('measurement');
            choice = (await response.json()).choice;
            panel.hidden = true;
            lastOpener?.focus();
        } catch (_) {
            if (action !== 'capture') error.hidden = false;
        } finally { busy = false; controls(); }
    }
    async function refresh() {
        try {
            const response = await fetch(endpoint, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
            if (!response.ok) return;
            const data = await response.json();
            csrf = data.csrf;
            choice = data.choice;
            enabled = data.enabled;
            controls();
            openers.forEach(button => { button.hidden = !enabled && choice === null; });
            if (enabled && choice === null) panel.hidden = false;
            if (enabled && choice === true && encoded) await send('capture');
        } catch (_) { /* Unavailable measurement never blocks shopping. */ }
    }
    actions.forEach(button => button.addEventListener('click', () => send(button.dataset.measurementAction)));
    openers.forEach(button => button.addEventListener('click', async () => {
        lastOpener = button;
        await refresh();
        panel.hidden = false;
        actions[0].focus();
    }));
    close.addEventListener('click', () => { panel.hidden = true; lastOpener?.focus(); });
    window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
    refresh();
}
